export default {
    id: 'orange-blue-green',
    colors: ['#FC7E6A', '#8CCBFF', '#A5ED8E'],
};
